import { Grid, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import LinkIcon from '@mui/icons-material/Link';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { SurveyActionsProps } from './props';
import { useSurveyListActions } from './hook';

export const SurveyListActions = ({
    id,
    status,
    onRefresh,
}: SurveyActionsProps) => {
    const {
        handleView,
        handleEdit,
        handleOpenSurvey,
        handleDuplicate,
        handleToggleStatus,
        duplicating,
        toggling,
        isActive,
    } = useSurveyListActions(id, status, onRefresh);

    // Función para detener la propagación del evento
    const stopPropagation = (e: React.MouseEvent, callback: () => void) => {
        e.stopPropagation();
        callback();
    };

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Abrir encuesta">
                <IconButton
                    size="small"
                    onClick={(e) => stopPropagation(e, handleOpenSurvey)}
                >
                    <LinkIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
            <Tooltip title="Duplicar">
                <IconButton
                    size="small"
                    onClick={(e) => stopPropagation(e, handleDuplicate)}
                    disabled={duplicating}
                >
                    <ContentCopyIcon
                        type="submit"
                        sx={{
                            color: duplicating ? 'grey.400' : 'primary.main',
                        }}
                    />
                </IconButton>
            </Tooltip>
            <Tooltip title="Ver">
                <IconButton
                    size="small"
                    onClick={(e) => stopPropagation(e, handleView)}
                >
                    <VisibilityIcon
                        type="submit"
                        sx={{ color: 'primary.main' }}
                    />
                </IconButton>
            </Tooltip>
            <Tooltip title="Editar">
                <IconButton
                    size="small"
                    onClick={(e) => stopPropagation(e, handleEdit)}
                >
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
            <Tooltip title={isActive ? 'Inactivar' : 'Activar'}>
                <IconButton
                    size="small"
                    onClick={(e) => stopPropagation(e, handleToggleStatus)}
                    disabled={toggling}
                >
                    {isActive ? (
                        <ToggleOnIcon sx={{ color: 'primary.main' }} />
                    ) : (
                        <ToggleOffIcon sx={{ color: 'primary.main' }} />
                    )}
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
